import React from "react";
import { motion } from "framer-motion";

export default function Home() {
  return (
    <section style={{
      background: "#0f172a",
      border: "1px solid #1e293b",
      padding: "2rem",
      borderRadius: "12px",
      boxShadow: "0 0 15px rgba(0, 255, 255, 0.08)",
      marginBottom: "2rem",
      textAlign: "center"
    }}>
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ color: "#00f9ff", fontSize: "2rem", fontWeight: "bold", marginBottom: "1rem" }}
      >
        Welcome to Rimsha Razi's Cybersecurity Portfolio
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        style={{ color: "#e2e8f0", fontSize: "1.1rem", maxWidth: "600px", margin: "0 auto" }}
      >
        🎯 A recent graduate in Cybersecurity Technology with a background in Aviation Management — I bring analytical precision and a relentless curiosity for securing systems. Dive into my labs, tools, and credentials to see how I turn threats into insights.
      </motion.p>
    </section>
  );
}
